var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.step < 3)?_c('div',{staticClass:"show_sidebar",attrs:{"id":"show_sidebar"},on:{"click":function($event){return _vm.revealSidebar()}}},[_vm._v(" "+_vm._s(_vm.showSidebarText)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }